import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "DataVis2"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 1.5H12.75C11.9219 1.50083 11.2508 2.17192 11.25 3V7.5H3C2.17192 7.50083 1.50083 8.17192 1.5 9V21C1.50083 21.8281 2.17192 22.4992 3 22.5H11.25C12.0781 22.4992 12.7492 21.8281 12.75 21V16.5H21C21.8279 16.4988 22.4988 15.8279 22.5 15V3C22.4992 2.17192 21.8281 1.50083 21 1.5ZM21 3V6H12.75V3H21ZM11.25 16.5H3V13.5H11.25V16.5ZM12.75 7.5H21L21.0008 10.5H12.75V7.5ZM11.25 9V12H3V9H11.25ZM3 21V18H11.2508V21H3ZM12.75 15V12H21.0015V15H12.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/DataVis2.vue"]]);
